import http from '../helpers/http';
import Keys from 'stateKeys';
import store from 'utilities/store';
import { DateTime } from 'luxon';

export default class ConfigRepository {
    storeConfiguration(config) {
        delete config.requesting;
        store.set(Keys.App.Config, config);
    }

    getStoredConfiguration() {
        return store.get(Keys.App.Config) || {};
    }

    getServerConfig() {
        return http.get('/api/v1/config');
    }
    
    getDenyReasons(lastUpdated) {
        return http.get('/api/v1/data/denyReasons' + (lastUpdated !== null ? `?lastUpdated=${DateTime.fromISO(lastUpdated)}` : ''));
    }
}